import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@gx-design/icon';
import { Button } from '@gx-design/button';

export let Header = ({ title, backLinkHref, hasBackBtn, hasBackLink, onBack, actions }) => (
    <div className="gx-head-section">
        {hasBackBtn && (
            <Button className="gx-button gx-button--iconOnly gx-head-section__back" iconOnly onClick={onBack}>
                <Icon name="arrow-left" />
            </Button>
        )}
        {hasBackLink && (
            <Button
                as="a"
                variant="ghost"
                className="gx-button gx-button--iconOnly gx-head-section__back"
                iconOnly
                href={backLinkHref}
            >
                <Icon name="arrow-left" />
            </Button>
        )}
        <div className="gx-head-section__title gx-title-1 gx-is-hidden-sm-down">{title}</div>
        {actions && <div className="gx-head-section__actions gx-buttonGroup gx-is-hidden-sm-down">{actions}</div>}
    </div>
);

Header.propTypes = {
    backLinkHref: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node]).isRequired,
    actions: PropTypes.any,
    hasBackBtn: PropTypes.bool,
    hasBackLink: PropTypes.bool,
    onBack: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};
